export const Tool = {
  Select: undefined,
  Pan: undefined,
  Add: undefined,
  Delete: undefined,
  Wand: undefined
}

Object.keys(Tool).forEach(k => { Tool[k] = k.toLowerCase() })

export const tools = {
  [Tool.Select]: {
    icon: 'selection',
    shortcut: 's',
    help: 'Select'
  },
  [Tool.Pan]: {
    icon: 'pan',
    shortcut: 'p',
    help: 'Move/scroll'
  },
  [Tool.Add]: {
    icon: 'pencil',
    shortcut: 'a',
    help: 'Add'
  },
  [Tool.Delete]: {
    icon: 'eraser',
    shortcut: 'e',
    help: 'Delete'
  },
  [Tool.Wand]: {
    icon: 'auto-fix',
    shortcut: 'w',
    help: 'Create a sequence'
  }
}

export const TriggerSpeed = {
  Fast: 'fast',
  Slow: 'slow'
}
